import { render, staticRenderFns } from "./CompanyInformationTab.vue?vue&type=template&id=2b37a384&"
import script from "./CompanyInformationTab.vue?vue&type=script&lang=js&"
export * from "./CompanyInformationTab.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInformationTab.vue?vue&type=style&index=0&id=2b37a384&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports